export const ValidateCardBinTransformer = (data: ValidateCardBin) => {
  return {
    bin: data.bin,
    type: data.type,
    isInternationalCard: data.isInternationalCard,
    networkType: data.networkType,
    issuerBank: data.issuerBank,
    issuerBankIconUrl: data?.issuerBankIconUrl,
    networkTypeIconUrl: data?.networkTypeIconUrl
  };
};
